<table class="table table-striped table-hover table-drivers-salary-days-list">
	<thead>
		<tr>
			<th *ngFor="let header of headers">
				<span>{{ header.label }}</span>
				@if (header.label === COUNTING_LABEL) {
					<mat-slide-toggle
						color="primary"
						(ngModelChange)="toggleAllIfNeeded($event)"
						[(ngModel)]="toggleAllCalculate"
						matTooltip="Zaznacz wszystko"
					></mat-slide-toggle>
				}
			</th>
		</tr>
	</thead>
	<tbody>
		<tr
			*ngFor="let item of data; let id = index"
			[ngClass]="{
				collision: item.haveDuplicateDay,
			}"
		>
			<td>{{ item.day }}</td>
			<td>{{ item.vehicleName }}</td>
			<td>
				<a routerLink="/tourism-events/{{ item.event }}" target="_blank">{{ item.name }}</a>
			</td>
			<td>{{ item.timeFrom }}</td>
			<td>{{ item.timeTo }}</td>
			<td>
				<div class="form-check mb-3">
					<input
						type="checkbox"
						class="form-check-input"
						[checked]="item.confirmed"
						[(ngModel)]="item.confirmed"
						name="confirmed_{{ id }}"
						[disabled]="true"
					/>
				</div>
			</td>
			<td>{{ item.rateKind_name }}</td>
			<td>
				<div class="form-check mb-3">
					<input
						type="checkbox"
						class="form-check-input"
						[checked]="item.isCalculate"
						[(ngModel)]="item.isCalculate"
						(ngModelChange)="checkToggleAll()"
						[disabled]="salary[0]?.confirmedDays"
						name="isCalculate_{{ id }}"
					/>
				</div>
			</td>
			<td>
				<select class="form-select me-5" [(ngModel)]="item.diet" [disabled]="salary[0]?.confirmedDays">
					<option *ngFor="let obj of diets" class="me-5" [disabled]="obj.disabled" [value]="obj.value">
						{{ obj.name }}
					</option>
				</select>
			</td>
			<td>
				<input
					type="number"
					class="form-control"
					[(ngModel)]="item.salary"
					[disabled]="salary[0]?.confirmedDays"
					name="salary_{{ id }}"
				/>
			</td>
			<td>
				<input
					type="number"
					class="form-control"
					[(ngModel)]="item.value"
					[disabled]="salary[0]?.confirmedDays"
					name="value_{{ id }}"
				/>
			</td>
			<td>
				<input
					type="text"
					class="form-control"
					[(ngModel)]="item.comment"
					[disabled]="salary[0]?.confirmedDays"
					name="comment_{{ id }}"
				/>
			</td>
		</tr>
	</tbody>
</table>
